/* Card colapsável — abre/fecha com animação (delegação no document) */
(function () {
  if (window.__ccolBound) return;
  window.__ccolBound = true;

  function content(row) {
    return row.querySelector('.ccol-row__content');
  }
  function open(row) {
    var c = content(row);
    row.classList.add('is-open');
    var head = row.querySelector('.ccol-row__head');
    if (head) head.setAttribute('aria-expanded', 'true');
    if (c) c.style.maxHeight = c.scrollHeight + 'px';
  }
  function close(row) {
    var c = content(row);
    row.classList.remove('is-open');
    var head = row.querySelector('.ccol-row__head');
    if (head) head.setAttribute('aria-expanded', 'false');
    if (c) c.style.maxHeight = '0px';
  }

  /* Ver mais / Ver menos dentro do conteúdo de uma aba */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ccol-readmore');
    if (!btn) return;
    e.preventDefault();
    var contentEl = btn.closest('.ccol-row__content');
    var inner = contentEl ? contentEl.querySelector('.ccol-clamp') : null;
    if (!inner) return;
    var expanded = inner.classList.toggle('is-expanded');
    btn.classList.toggle('is-open', expanded);
    btn.textContent = expanded ? (btn.dataset.less || 'Ver menos') : (btn.dataset.more || 'Ver mais');
    /* se a aba estiver animada por max-height, reajusta pra caber o novo tamanho */
    var row = btn.closest('.ccol-row');
    var mh = contentEl.style.maxHeight;
    if (row && row.classList.contains('is-open') && mh && mh !== 'none' && mh !== '0px') {
      contentEl.style.maxHeight = contentEl.scrollHeight + 'px';
    }
  });

  document.addEventListener('click', function (e) {
    var head = e.target.closest('.ccol-row__head');
    if (!head) return;
    var card = head.closest('.ccol-card');
    if (!card || card.dataset.behavior === 'always_open') return;
    var row = head.closest('.ccol-row');
    if (!row) return;

    var willOpen = !row.classList.contains('is-open');
    if (card.dataset.behavior === 'accordion' && willOpen) {
      card.querySelectorAll('.ccol-row.is-open').forEach(function (r) {
        if (r !== row) close(r);
      });
    }
    if (willOpen) open(row); else close(row);
  });

  function initOpenRows() {
    document
      .querySelectorAll('.ccol-card:not([data-behavior="always_open"]) .ccol-row.is-open')
      .forEach(function (row) {
        var c = content(row);
        if (c) c.style.maxHeight = c.scrollHeight + 'px';
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOpenRows);
  } else {
    initOpenRows();
  }
  window.addEventListener('resize', function () {
    document
      .querySelectorAll('.ccol-card:not([data-behavior="always_open"]) .ccol-row.is-open')
      .forEach(function (row) {
        var c = content(row);
        if (c) c.style.maxHeight = c.scrollHeight + 'px';
      });
  });
})();
